import { SelectProductsList } from "@repo/core/components/layout/SelectProductsList";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

import { SelectProductController } from "./controller";

export const SelectProduct = () => {
  const {
    back,
    handleOnSubmitForm,
    handleBack,
    selectedProductId,
    products,
    isFetchingProducts,
    handleSelectProduct
  } = SelectProductController();

  return (
    <PageScaffold
      isLoading={isFetchingProducts}
      loadingTitle="Carregando produtos"
      loadingDescription="Aguarde enquanto carregamos os produtos"
      onBackPress={back}
      onPressRightIcon={handleBack}
      rightWebLabel="Fechar"
      title="Produto"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
          secondaryText="Cancelar"
          secondaryOnPress={handleBack}
        />
      }
    >
      <SelectProductsList
        products={products || []}
        selectedProduct={selectedProductId}
        onSelectProduct={handleSelectProduct}
      />
    </PageScaffold>
  );
};
